var faq = {
  init: function () {
    $(".open_faq").click(function () {
      $(this).next(".content_faq").slideToggle();
      $(this).children("span").toggleClass("active");
    });
  },
  hash: function ($target) {
    if ($("#p-faq")[0]) {
      var _posi = $($target).offset().top - $("#l-header__fixed").height();

      if ($($target).children(".content_faq")[0]) {
        $($target).children(".content_faq").css("display", "block");
      }
      setTimeout(function () {
        $(window).scrollTop(_posi);
      }, 6e2);
    }
  },
};

if ($("#p-faq .content_faq").length > 1) {
  $(".content_faq").css("display", "none");
  faq.init();
}

$(window).on("load", function () {
  // tabのときは動作させない
  if (location.hash === "#tab") {
    return;
  }
  if (location.hash) {
    faq.hash(location.hash);
  }
});
